import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./style.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import Table from "../../../../views/Table/Table.js";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import DownloadPartInventory from "./DownloadPartInventory";
const Inventory = (props) => {
  console.log('Part Inventory');
  console.log(props);
  const [data, setData] = React.useState(false);

  React.useEffect(() => {
    axios({
      url: "/getproductsInWarehouse",
      method: "post",
      data: {
        userId: props.user._id,
        warehouseId: props.warehouse._id,
        partId: props.value._id,
      },
    }).then((res) => {
      if (res.data.success) {
        if (res.data.data.length > 0) {
          setData(res.data.data);
          console.log("parts");
          console.log(res.data.data);
        } else {
          setData("NO_DATA");
        }
      } else {
        props.setAlert("Something went wrong try again");
        props.onClose();
      }
    });
  }, []);

  let parts = [];
  data &&
    data != "NO_DATA" &&
    data.forEach((val) => {
      parts.push([
        val.productPartId.partName,
        val.partUnitCode,
        val.productPartId.height,
        val.productPartId.length,
        val.productPartId.weight,
        val.productPartId.width,
        val.productPartId.status,
        val.godown ? val.godown.name : "NULL",
        val.location ? val.location.name : "NULL",
      ]);
    });

  const isLoading = !data;
  const noData = data == "NO_DATA";
  const showData = !isLoading && !noData;
  // var b = data[0].warehouse;
  return (
    <Dialog
      open={props.value}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>Warehosue Part Inventory</h1>
            <div style={{ justifyContent: "flex-end" }}>
              {showData && (
                <DownloadPartInventory
                  details={parts}
                  name={data[0].warehouse}
                />
              )}
              <IconButton onClick={props.onClose}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </div>
          {noData && (
            <div className={styles.loader}>
              <h4>Warehouse does not have any inventory</h4>
            </div>
          )}

          {showData && (
            <div className={styles.content}>
              <h2>Warehouse Detail</h2>

              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Name",
                  "Bar Code",
                  "Address",
                  "Location",
                  "Contact Number",
                ]}
                tableData={[
                  [
                    data[0].warehouse.name,
                    data[0].warehouse.warehouse_barcode,
                    data[0].warehouse.address,
                    data[0].warehouse.warehouseLocation,
                    data[0].warehouse.contactNum,
                  ],
                ]}
              />
              {console.log(data[0].warehouse)}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "20px",
                }}
              >
                {" "}
              </div>
              <h2>Parts Details</h2>
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Name",
                  "Part Unit Code",
                  "Height",
                  "Length",
                  "weight",
                  "width",
                  "status",
                  "GoDown",
                  "Location",
                ]}
                tableData={parts}
              />
            </div>
          )}

          {isLoading && (
            <div className={styles.loader}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default Inventory;
